export const FACET_VALUE_TRUNCATION_THRESHOLD = 10;

export const SINGLE_SELECT_FACET_FIELDS = {
  pricingTag: true,
  txAttrFacet_Gender: true,
  zc1: true,
  zc2: true,
  zc3: true,
  zc4: true
} as const;
